import { Injectable } from '@angular/core';
import { BaseConfigService } from '@lx/shared/app-config';
import { ApiEnvironment, RuntimeEnvironment } from '@lx/shared/types';

@Injectable()
export class StorybookConfigService extends BaseConfigService {
  protected fetchApiEnvironment({ API_BASE_PATH }: RuntimeEnvironment): ApiEnvironment {
    return {
      API_BASE_PATH,
    };
  }
}
